export const cibFigma = ["32 32","<path d='M16 16c0-7.109 10.667-7.109 10.667 0s-10.667 7.109-10.667 0zM5.333 26.667c0-2.948 2.385-5.333 5.333-5.333h5.333v5.333c0 7.109-10.667 7.109-10.667 0zM16 0v10.667h5.333c7.109 0 7.109-10.667 0-10.667zM5.333 5.333c0 2.948 2.385 5.333 5.333 5.333h5.333v-10.667h-5.333c-2.948 0-5.333 2.385-5.333 5.333zM5.333 16c0 2.948 2.385 5.333 5.333 5.333h5.333v-10.667h-5.333c-2.948 0-5.333 2.385-5.333 5.333z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-figma.js
// module id = null
// module chunks = 